module.exports = __webpack_public_path__ + "static/media/Colette Velvet Queen Base - 155x205 cm_Black.3d3f4f1d.png";